import "../../../css/buttons/PrimaryButton.css";


const scrollToContact = () => {
  document
    .getElementById("contact-us")
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
};

const PrimaryButtonSmall = ({
  onClick,
  text,
  type = "button",
  disabled = false,
  className = "",
  ...buttonProps
}) => {
  const handleClick = onClick || scrollToContact;

  return (
    <button
      type={type}
      className={`primary-button ${className}`.trim()}
      disabled={disabled}
      onClick={handleClick}
      {...buttonProps}
    >
      <div className="button-text-small">{text}</div>
    </button>
  );
};

export default PrimaryButtonSmall;
